import { appHeaderHeight } from '@/style/constants';
import { styled } from '@abyss/web/tools/styled';

export const AppLayoutBody = styled('main', {
  minHeight: `calc(100vh - ${appHeaderHeight})`,
});
